<h3>Kontakt</h3>

<p>Sollten Sie Probleme oder andere Fragen haben, können Sie uns darüber informieren, wir bemühen uns um eine
  schnelle Rückmeldung. Auch können Sie uns telefonisch erreichen. Unsere Kontaktdaten sind wie folgt:
</p>

<mat-card>
  <mat-card-header>
    <mat-card-title>Adresse</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Matthias Jung<br>
    Schloßstr. 17<br>
    86732 Oettingen in Bayern
  </mat-card-content>
</mat-card>
<br>
<mat-card>
  <mat-card-header>
    <mat-card-title>Nachricht</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Telefon: 09082 2910<br>
    E-Mail: <a href="mailto:matthias@darwins-reisen.de">matthias@darwins-reisen.de</a><br>
    Facebook: <a href="https://www.facebook.com/profile.php?id=165646686816548">DARWINs-Board-Shop</a>
  </mat-card-content>
</mat-card>
<br>
<mat-card>
  <mat-card-header>
    <mat-card-title>Öffnungszeiten</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Mo: 13:30 – 18:00 Uhr<br>
    Di: 09:00 – 12:00 u. 13:30 – 18:00<br>
    Mi: 09:00 – 12:00 u. 13:30 – 18:00<br>
    Do: 09:00 – 12:00 u. 13:30 – 18:00<br>
    Fr: 09:00 – 12:00 u. 13:30 – 18:00<br>
    Sa: 08:30 – 12:30 Uhr
  </mat-card-content>
</mat-card>
<!--
<br>
<mat-card>
  <mat-card-header>
    <mat-card-title>Bankverbindung</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Sparkasse Donauwörth<br>
    Iban: DE 10722501600240100057<br>
    Swift: BYLADEM1DON
  </mat-card-content>
</mat-card>
-->
